!function() {
  "use strict";

  customElements.get("timeline-slider") || customElements.define("timeline-slider", class extends HTMLElement {
    constructor() {
      super();
      this.carousel = null;
      this.cards = null;
      this.activeIndex = 0;
      this.arrowsContainer = null;
      this.prevBtn = null;
      this.nextBtn = null;

      // Bound methods
      this.onResizeCallback = () => this.onResize();
      this.onCardClickCallback = (e) => this.onCardClick(e);
    }

    connectedCallback() {
      this.carousel = this.querySelector('[data-timeline-carousel]');
      this.cards = this.querySelectorAll('[data-slide]');
      this.container = this.closest('[data-section-type="timeline-slider"]');

      if (!this.carousel || this.cards.length < 2) return;

      this.init();
      this.bindEvents();

      document.addEventListener('theme:resize:width', this.onResizeCallback);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:resize:width', this.onResizeCallback);
      this.carousel?.removeEventListener('click', this.onCardClickCallback);

      if (this.arrowsContainer) {
        this.arrowsContainer.remove();
      }
    }

    init() {
      // Set first card as active
      this.setActiveCard(0);

      // Create navigation arrows
      this.createCustomArrows();

      // Initial arrow state
      this.updateArrowStates();
    }

    createCustomArrows() {
      const showArrows = this.dataset.showArrows === 'true';
      if (!showArrows) return;

      // Arrow SVG icons
      const arrowLeftSvg = `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-1" y="1" width="42" height="42" rx="21" transform="matrix(-1 0 0 1 42 0)" fill="white"/>
<rect x="-1" y="1" width="42" height="42" rx="21" transform="matrix(-1 0 0 1 42 0)" stroke="#145EAE" stroke-width="2"/>
<path d="M21.2106 13.0001C21.4666 12.9958 21.724 13.0949 21.9225 13.2986C22.319 13.7062 22.3295 14.3786 21.945 14.7994L16.3442 20.9382H30.0156C30.5676 20.9382 31.0156 21.4137 31.0156 21.9996C31.0156 22.5854 30.5676 23.0609 30.0156 23.0609H16.3442L21.945 29.1997C22.329 29.6205 22.319 30.2924 21.9225 30.7005C21.728 30.9 21.4767 31 21.2262 31C20.9652 31 20.7039 30.8921 20.5084 30.6766L13.266 22.7375C12.8905 22.3262 12.8905 21.6729 13.266 21.2616L20.5084 13.3225C20.6999 13.1118 20.9546 13.0045 21.2106 13.0001Z" fill="#145EAE"/>
</svg>`;

      const arrowRightSvg = `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1" y="1" width="42" height="42" rx="21" fill="white"/>
<rect x="1" y="1" width="42" height="42" rx="21" stroke="#145EAE" stroke-width="2"/>
<path d="M22.7894 13.0001C22.5334 12.9958 22.276 13.0949 22.0775 13.2986C21.681 13.7062 21.6705 14.3786 22.055 14.7994L27.6558 20.9382H13.9844C13.4324 20.9382 12.9844 21.4137 12.9844 21.9996C12.9844 22.5854 13.4324 23.0609 13.9844 23.0609H27.6558L22.055 29.1997C21.671 29.6205 21.681 30.2924 22.0775 30.7005C22.272 30.9 22.5233 31 22.7738 31C23.0348 31 23.2961 30.8921 23.4916 30.6766L30.734 22.7375C31.1095 22.3262 31.1095 21.6729 30.734 21.2616L23.4916 13.3225C23.3001 13.1118 23.0454 13.0045 22.7894 13.0001Z" fill="#145EAE"/>
</svg>`;

      // Create container
      this.arrowsContainer = document.createElement('div');
      this.arrowsContainer.className = 'timeline__arrows';

      // Create prev button
      this.prevBtn = document.createElement('button');
      this.prevBtn.type = 'button';
      this.prevBtn.className = 'timeline__arrow timeline__arrow--prev';
      this.prevBtn.setAttribute('aria-label', 'Previous');
      this.prevBtn.innerHTML = arrowLeftSvg;

      // Create next button
      this.nextBtn = document.createElement('button');
      this.nextBtn.type = 'button';
      this.nextBtn.className = 'timeline__arrow timeline__arrow--next';
      this.nextBtn.setAttribute('aria-label', 'Next');
      this.nextBtn.innerHTML = arrowRightSvg;

      // Bind click events - activate prev/next card
      this.prevBtn.onclick = (e) => {
        e.preventDefault();
        this.goToPrev();
      };

      this.nextBtn.onclick = (e) => {
        e.preventDefault();
        this.goToNext();
      };

      this.arrowsContainer.appendChild(this.prevBtn);
      this.arrowsContainer.appendChild(this.nextBtn);

      // Insert after carousel
      this.carousel.after(this.arrowsContainer);
    }

    goToPrev() {
      if (this.activeIndex > 0) {
        this.setActiveCard(this.activeIndex - 1);
        this.updateArrowStates();
      }
    }

    goToNext() {
      if (this.activeIndex < this.cards.length - 1) {
        this.setActiveCard(this.activeIndex + 1);
        this.updateArrowStates();
      }
    }

    updateArrowStates() {
      if (!this.prevBtn || !this.nextBtn) return;

      // Disable prev at first card
      this.prevBtn.disabled = this.activeIndex === 0;

      // Disable next at last card
      this.nextBtn.disabled = this.activeIndex === this.cards.length - 1;
    }

    bindEvents() {
      // Card click - toggles active state
      this.carousel.addEventListener('click', this.onCardClickCallback);
    }

    onCardClick(event) {
      const card = event.target.closest('[data-slide]');
      if (!card) return;

      const index = parseInt(card.dataset.cardIndex);

      // Set active card
      if (index !== this.activeIndex) {
        this.setActiveCard(index);
        this.updateArrowStates();
      }
    }

    setActiveCard(index) {
      this.activeIndex = index;

      // Toggle classes - cards expand in-place via CSS
      this.cards.forEach((card, i) => {
        if (i === index) {
          card.classList.add('is-active');
          card.setAttribute('aria-current', 'true');
        } else {
          card.classList.remove('is-active');
          card.removeAttribute('aria-current');
        }
      });

      // Auto-scroll to keep active card visible
      this.scrollToActiveCard(index);
    }

    scrollToActiveCard(index) {
      const card = this.cards[index];
      if (!card) return;

      // Wait for CSS transition to start, then scroll
      requestAnimationFrame(() => {
        const cardLeft = card.offsetLeft;
        const cardWidth = card.offsetWidth;
        const carouselWidth = this.carousel.clientWidth;
        const scrollLeft = this.carousel.scrollLeft;

        // Calculate target scroll position to center the card (or show it properly)
        let targetScroll;

        if (index === 0) {
          // First card - scroll to start
          targetScroll = 0;
        } else {
          // Center the active card in view
          targetScroll = cardLeft - (carouselWidth / 2) + (cardWidth / 2);
        }

        // Clamp to valid scroll range
        const maxScroll = this.carousel.scrollWidth - carouselWidth;
        targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));

        // Smooth scroll to target
        this.carousel.scrollTo({
          left: targetScroll,
          behavior: 'smooth'
        });
      });
    }

    onResize() {
      this.updateArrowStates();
    }
  });
}();
